/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { GridControl } from '@src/app/shared/grid/grid-control';
import { GridComponent } from '@src/app/shared/grid/grid.component';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';

/**
 * The simple attachment list's "expand" control opens this - the same attachments in the full
 * grid, in a large window. Its own component (rather than a generic one) so it can grow its own
 * way later, e.g. a sortable/searchable table.
 */
@Component({
    selector: 'app-attachment-list-dialog',
    imports: [MatDialogModule, DialogBannerComponent, GridComponent],
    template: `
        <app-dialog-banner text="Attachments" [dialogRef]="dialogRef"></app-dialog-banner>
        <mat-dialog-content class="body">
            <app-grid [control]="data.control" on="form"></app-grid>
        </mat-dialog-content>
    `,
    styles: [`
        .body {
            width: 80vw;
            max-width: 1100px;
            min-height: 50vh;
            padding-top: 12px;
        }
    `]
})
export class AttachmentListDialogComponent {
    dialogRef = inject<MatDialogRef<AttachmentListDialogComponent>>(MatDialogRef);
    data = inject<{ control: GridControl }>(MAT_DIALOG_DATA);
}
